var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarSuffixIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81437 0.373023C9.69076 0.249307 9.54423 0.1875 9.37492 0.1875H0.625047C0.455668 0.1875 0.30924 0.249307 0.185523 0.373023C0.0618069 0.496877 0 0.643305 0 0.812581C0 0.981824 0.0618069 1.12825 0.185523 1.252L4.56048 5.62696C4.68433 5.75067 4.83076 5.81262 5 5.81262C5.16924 5.81262 5.31581 5.75067 5.43942 5.62696L9.81437 1.25197C9.93795 1.12825 10 0.981824 10 0.812547C10 0.643305 9.93795 0.496877 9.81437 0.373023Z",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSuffixIcon);
export default __webpack_public_path__ + "static/media/calendarSuffixIcon.1f7538aaee8941e95bc3625a669e0270.svg";
export { ForwardRef as ReactComponent };